import * as React from "react";
import { cn } from "./utils";
import { type LucideIcon } from "lucide-react";

export interface FormSectionCardProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: LucideIcon;
    iconColor?: string;
    iconBgColor?: string;
    title: string;
    description?: string;
}

const FormSectionCard = React.forwardRef<HTMLDivElement, FormSectionCardProps>(
    (
        {
            className,
            icon: Icon,
            iconColor = "text-blue-600",
            iconBgColor = "bg-blue-100",
            title,
            description,
            children,
            ...props
        },
        ref
    ) => {
        return (
            <div ref={ref} className={cn("bg-white shadow-sm border border-gray-200 rounded-lg", className)} {...props}>
                <div className="p-6 border-gray-200 border-b">
                    <div className="flex items-center gap-3">
                        {Icon && (
                            <div className={cn("p-2 rounded-lg", iconBgColor)}>
                                <Icon className={cn("w-5 h-5", iconColor)} />
                            </div>
                        )}
                        <div className="flex-1">
                            <h3 className="font-semibold text-lg">{title}</h3>
                            {description && <p className="mt-1 text-slate-600 text-sm">{description}</p>}
                        </div>
                    </div>
                </div>
                <div className="space-y-4 p-6">{children}</div>
            </div>
        );
    }
);

FormSectionCard.displayName = "FormSectionCard";

export { FormSectionCard };
